import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import styleVars from './styles/variables';
import content from './content/tabBar';

const Tab = styled.nav`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  height: fit-content;
`;

const activeTab = 'nav-item-active';

const TabLink = styled(NavLink)<{styleType: string}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-height: 25px;
  border-right: 1px solid white;
  line-height: 1.4em;
  font-family: Whitney-Bold;
  font-size: ${styleVars.fontSizes.smallest};
  background-color: ${(props) => (props.styleType === 'about' ? styleVars.colors.darkPurple : styleVars.colors.darkTeal)};
  text-align: center;
  color: white;
  transition: 0.2s all ease-out;
  padding: ${(props) => (props.styleType === 'about' ? '2%' : '1%')}

  &:hover {
    background-color: ${(props) => (props.styleType === 'about' ? styleVars.colors.brandPurple : styleVars.colors.brandTeal)};
  }

  &.${activeTab} {
    background-color: ${(props) => (props.styleType === 'about' ? styleVars.colors.brandPurple : styleVars.colors.brandTeal)};
  }

  &.${activeTab} > :first-child {
    background-color: ${styleVars.colors.brandOrange};
  }

  &:last-child {
    border-right: none;
  }

  @media (max-width: ${styleVars.media.tablet}) {
    justify-content: center;
    min-height: 45px;
    font-size: ${styleVars.fontSizes.smaller};
  }
`;

const TabNumber = styled.div`
  transition: 0.2s all ease-out;
  background-color: transparent;
  padding-left: 5px;
  padding-right: 5px;

  @media (max-width: ${styleVars.media.tablet}) {
    font-size: ${styleVars.fontSizes.small};
    justify-content: center;
    padding: 5px 7px;
  }
`;

const TabTitle = styled.div`
  @media (max-width: ${styleVars.media.tablet}) {
     display: none;
  }
`;

const TabBar: React.FC<{styleType: string}> = ({ styleType }) => {
  const renderAboutTabs = content.about.map((tab: any) => (
    <TabLink
      styleType={styleType}
      activeClassName={activeTab}
      to={tab.url}
    >
      {tab.title}
    </TabLink>
  ));

  const renderImpactTabs = content.impact.map((tab: any, index: number) => (
    <TabLink
      styleType={styleType}
      activeClassName={activeTab}
      to={tab.url}
    >
      <TabNumber>{index + 1}</TabNumber>
      <TabTitle>{tab.title}</TabTitle>
    </TabLink>
  ));

  return (
    <Tab>
      {styleType === 'about' ? renderAboutTabs : renderImpactTabs}
    </Tab>
  );
};

export default TabBar;
